<template>
    <modal-cadu close :width="600" style="overflow: hidden;" v-model="valueData">
        <div slot="all" class="pa-6 px-8">
          <div slot="header">
            <div class="line-bottom title">
              {{titulo}}
            </div>
          </div>
          <div slot="body" class="pb-5 pt-5">
              <div class="fontColor--text subtitle-1 ml-8 mt-1">
                {{errObj.error}}
              </div>
          </div>
          <div slot="footer" class="mt-4">
            <v-row justify="end" no-gutters>
              <v-col cols="auto">
                <slot name="footer-buttons">
                  <button-cadu @click="$emit('input', false)">
                    OK
                  </button-cadu>
                </slot>
              </v-col>
            </v-row>
          </div>
        </div>
    </modal-cadu>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    errObj: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      required: false,
      default: 'Há algo errado.'
    }
  },
  data () {
    return {
      valueData: this.value
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="sass">
.v-alert__icon
    height: auto !important

.line-bottom
  border-bottom: 1px solid #CCCCCC
  padding-bottom: 10px

</style>
